module.exports = __webpack_public_path__ + "static/img/doc.b3aed6d6.png";